import { SVGProps, Ref, forwardRef } from 'react';

export const StarCircleOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m8.576 13.21-.328-.294c-1.62-1.452-2.429-2.178-2.214-2.87s1.278-.781 3.405-.961l.452-.038.183-.458C10.894 6.529 11.304 5.5 12 5.5s1.106 1.03 1.927 3.089l.182.458.452.038c2.127.18 3.19.27 3.405.961.215.692-.595 1.418-2.214 2.87l-.35.314.102.447c.493 2.17.74 3.255.177 3.683s-1.473-.154-3.294-1.315l-.4-.255-.4.255c-1.822 1.161-2.732 1.742-3.295 1.315s-.316-1.513.178-3.683z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1M4.789 5.59C3.424 7.228 2.8 9.517 2.8 12s.624 4.772 1.989 6.41C6.106 19.99 8.308 21.2 12 21.2s5.894-1.21 7.211-2.79C20.576 16.772 21.2 14.483 21.2 12s-.624-4.772-1.989-6.41C17.894 4.01 15.692 2.8 12 2.8S6.106 4.01 4.789 5.59"
                fill="currentColor"
            />
        </g>
    </svg>
));
StarCircleOutlinedSize24Glyph.displayName = 'StarCircleOutlinedSize24Glyph';
